import { Component, HostListener, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'dp-works-master-search';
  deviceInfo: any
  isDesktop: boolean = true
  isMobile: boolean = false;
  constructor(
    private deviceS: DeviceDetectorService
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.getScreenSize()
  }

  getScreenSize() {
    this.isDesktop = (window.innerWidth >= 1024 ) ? true : false
    if(!this.isDesktop){
      sessionStorage.clear();
      localStorage.clear();
    }
    console.log(`DEVICE TYPE: ${this.isDesktop}`)
  }

  ngOnInit(): void {
    this.isMobile = this.deviceS.isMobile();
    this.deviceInfo = this.deviceS.getDeviceInfo()
    console.log(this.deviceInfo.deviceType)
    this.isDesktop = (this.deviceInfo.deviceType === 'desktop') && !this.isMobile ? true : false;
    if(!this.isDesktop){
      sessionStorage.clear();
      localStorage.clear();
    }
  }
}
